setTimeout(function(e){
  class VariantRadios extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);    
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      if (!this.currentVariant){
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      }else {
        this.updateMedia();
        this.updateVariantInput();
        this.updateURL();
        this.renderProductInfo();
      }
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      var fetured_id = this.currentVariant.featured_media.id;
      if(document.querySelector('.media-grid-inner')){
        document.querySelectorAll('.media-grid-inner').forEach(function(e){
          var mediaid = e.dataset.id;
          var mediaindex = e.dataset.index;
          if(mediaid==fetured_id){          
            var flkty = new Flickity('.media-slider');
            flkty.select(mediaindex);           
          }
        });
      }
    }
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
      const fieldlen = fieldsets.length;
      let option_count = 0;
      fieldsets.forEach(function(eachfield){
        var checked_gender = eachfield.querySelector('input:checked');
        if(checked_gender){
          option_count++;
        }
      });
      this.options = fieldsets.map((fieldset) => {
        if(option_count>=fieldlen){
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        }
      });
    }
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const mob_id = `mobprice-${this.dataset.section}`;
        const mob_html = new DOMParser().parseFromString(responseText, 'text/html')
        const mob_destination = document.getElementById(mob_id);
        const mob_source = mob_html.getElementById(mob_id);
        if (mob_source && mob_destination) mob_destination.innerHTML = mob_source.innerHTML;

        const vatid = `vat-${this.dataset.section}`;
        const htmlnew = new DOMParser().parseFromString(responseText, 'text/html')
        const destinationvat = document.getElementById(vatid);
        const sourcenew = htmlnew.getElementById(vatid);
        if (sourcenew && destinationvat) destinationvat.innerHTML = sourcenew.innerHTML;
        
        const mob_vatid = `mobvat-${this.dataset.section}`;
        const mob_htmlnew = new DOMParser().parseFromString(responseText, 'text/html')
        const mob_destinationvat = document.getElementById(mob_vatid);
        const mob_sourcenew = mob_htmlnew.getElementById(mob_vatid);
        if (mob_sourcenew && mob_destinationvat) mob_destinationvat.innerHTML = mob_sourcenew.innerHTML;
        
        if(this.currentVariant){
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        $('.product-addcart').addClass('hidecartbtn');
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
        $('.product-addcart').removeClass('hidecartbtn');
      }
      if (!modifyClass) return;
    }
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-radios', VariantRadios);
  function variant_drodown(){
    if(document.querySelector('.dropdown-wrap')){
      document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
        dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
          event.preventDefault();
          dropdown.classList.toggle('active');
          if (dropdown.classList.contains('active')) {
            dropdown.querySelectorAll('input[type="radio"]').forEach(function(e) {
              e.addEventListener('change', function(button) {
                dropdown.classList.remove('active');
                dropdown.querySelector('.variant-dropdown').textContent = this.value;
              });
            });
          }
        });
      });
    }
  }
  if(document.querySelector('.product-addcart')){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var cartform = document.querySelector('.product-addcart').closest('form');
    const formData = new FormData(cartform);  
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        $('.cartsucess').hide();
        $('.carterror').show();
        document.querySelector('.carterror').innerHTML = response.description;   
        $('.product-form-error').html(response.description);
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
          document.querySelector('body').classList.remove('open-canotification');
          $('.product-form-error').html('');
        },3000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          if($(window).width() > 992){
            $('body').toggleClass('open-drawer');
          }else{
            $('.cartsucess').show();
            $('.carterror').hide();
            setTimeout(function(e){
              document.querySelector('body').classList.add('open-canotification');
            },500);
            setTimeout(function(e){
              document.querySelector('body').classList.remove('open-canotification');
            },3000); 
          }          
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
  
    });
  });
  }
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  function product_slider(){
    if(document.querySelector('.media-slider')){
      var elem = document.querySelector('.media-slider');
      const image_elements = Array.from(document.querySelectorAll('.media-grid-inner'));
      let count = 0;
      let showButtons = true;
      image_elements.map(()=>{
        count++;
      })
      if(count < 2){
        showButtons = false;
      }
      

      var flkty = new Flickity( elem, {
        /*cellAlign: 'left',
        contain: true,*/
        prevNextButtons: showButtons,
        draggable: true
      });
    }
  }
  product_slider();
  variant_drodown();
  document.addEventListener("shopify:section:load", function(event) {
    product_slider();
    variant_drodown();
  });
  var allcontentlist = document.querySelectorAll('.product-tablist li');
  allcontentlist.forEach(function(e){
      e.addEventListener('click',function(evt){
        evt.preventDefault();
          var currentTab = this.dataset.title;          
          var activeclass = document.querySelectorAll(".product-tablist li");
          activeclass.forEach(function(e){
            e.classList.remove('active');
          });
          this.classList.add('active');
          document.querySelectorAll(".tab-content").forEach(function(tabClass){
            tabClass.classList.remove('active');
          });
          document.querySelector('.tab-content[data-tab='+currentTab+']').classList.add('active');
      }); 
  });
  var enquirebtns = document.querySelectorAll('.toggle-enquire,.backfrom');
  enquirebtns.forEach(function(BtnsEnquire){
      BtnsEnquire.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.toggle('open-enquire');
      });
  });
  var firstmediaId = document.querySelector('.media-slider').dataset.firstid;
  if(document.querySelector('.media-grid-inner')){
    document.querySelectorAll('.media-grid-inner').forEach(function(e){
      var mediaid = e.dataset.id;
      var mediaindex = e.dataset.index;
      if(mediaid==firstmediaId){          
        var flkty = new Flickity('.media-slider');
        flkty.select(mediaindex);           
      }
    });
  }  
  document.querySelector('.zooomclose').addEventListener('click',function(event){
    event.preventDefault();
    document.querySelector('body').classList.remove('openzoom');
    $('.zoomslides').removeClass('currenctZoom');
  });
  /*document.querySelector('.zoom_icon').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('openzoom');
    var currentslide = document.querySelector('.media-grid-inner.is-selected').dataset.index;    
    if(document.querySelector('.mainzoomslider')){
      var elem = document.querySelector('.mainzoomslider');
      var flktys = new Flickity( elem, {
        prevNextButtons: true,
        pageDots: false
      });
      flktys.select(currentslide); 
      var carouselStatus = document.querySelector('.count-current');
      function updateStatus() {
        var slideNumber = flktys.selectedIndex + 1;
        carouselStatus.textContent = slideNumber;
        var allSlides = document.querySelectorAll('.zoomslides:not(.is-selected)');
        allSlides.forEach(function(e){
          var openzoomclass = document.querySelector('.currenctZoom');
          if(openzoomclass){
            e.classList.remove('currenctZoom');
            e.querySelector('img').style.width = 'auto';
          }
        }); 
      }
      updateStatus();
      flktys.on( 'select', updateStatus );
    }
  });
  $('.zoomicon').on('click',function(event){
    event.preventDefault();
    if(document.querySelector(".zoomslides.is-selected img")){
      var myImg = document.querySelector(".zoomslides.is-selected img");
      var windowidth = document.querySelector('body').clientWidth;
      if(myImg.closest('.zoomslides')){
        var parentImg = myImg.closest('.zoomslides').classList.add('currenctZoom');
        var currWidth = myImg.clientWidth;
        if (currWidth == 4500) return false;
        else {
          myImg.style.width = (currWidth + 100) + "px";          
        }
      }
    }
  });*/
  $('.pdp-acco-title').on('click',function(e){
    $(this).next('.pdp-acco-desc').slideToggle();
  });
  $('.pdp-cartdrawer').on('click',function(e) {
    $('body').toggleClass('open-drawer');
  });
  $('.pdp-cartoverlay,.noti_close').on('click',function(e) {
    e.preventDefault();
    $('body').removeClass('open-canotification');
  });  
  $('#enq_name,#enq_email,#enq_question').on('input',function(e){
    var enq_name = $('#enq_name').val();
    var enq_email = $('#enq_email').val();
    var enq_que = $('#enq_question').val();
    if(enq_name.length != 0 && enq_email.length != '' && enq_que.length != '' ){
      $('.send_enquire').addClass('activeorange');      
    }else{
      $('.send_enquire').removeClass('activeorange');      
    }
  });
},1000);
$('.fancybox').fancybox({
  padding : 0,
  openEffect  : 'elastic',
  closeBtn: false,
  selector : '[rel="gallery"]',
  loop     : true
});


